import React, {
  Fragment,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from "react";

import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Request from "core/requests";
import { Loading } from "components/common";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  useMediaQuery,
} from "@mui/material";
import MainCard from "components/common/card/MainCard";
import WarningListTable from "components/tables/warning-list/WarningListTable.component";
import { ListPagination } from "components/tables/list";
import ErrorCardcomponent from "components/common/card/ErrorCard.component";
import { saveCluster, saveSearch } from "store/user.store";
import { openSnackbar } from "store/slices/snackbar";
import { refreshToken, logout } from "store/user.store";
import { useTheme } from "@emotion/react";
import ToolbarTableComponent from "components/tables/toolbar/ToolbarTable.component";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const optionsChecked = {
  GATEWAY: false,
  ENVSENSOR: false,
  CAMERA: false,
  PCOUNTER: false,
  WIFI: false,
};

const SUPERUSER = "superuser";
const OPERATOR = "operator";

const WarningListContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchXS = useMediaQuery(theme.breakpoints.only("xs"));
  const [isVisitor, setIsVisitor] = useState(true);

  const { token, search, cluster, refresh_token, user } = useSelector(
    (state) => state.user
  );

  const [page, setPage] = useState(0);
  const [slice, setSlice] = useState(25);
  const [count, setCount] = useState(0);
  const [listClusters, setListClusters] = useState([]);
  const [zoneSelected, setZoneSelected] = useState(cluster ? cluster : []);
  const [loading, setLoading] = useState(true);
  const [loadingZone, setLoadingZone] = useState(true);
  const [values, setValues] = useState(null);
  const [dataFilter, setDataFilter] = useState([]);
  const [checked, setChecked] = useState({ inattivi: false, mutati: false });
  const [refresh, setRefresh] = useState(false);
  const [valueSearch, setValueSearch] = useState(search ? search : "");
  const [checkedType, setCheckedType] = useState(optionsChecked);
  const [dataFinal, setDataFinal] = useState([]);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [allStations, setAllStations] = useState(null);
  const [warning, setWarning] = useState(true);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("stationId");
  const [isFirstLoading, setIsFirstLoading] = useState(true);

  const TABLE_HEAD_VISITOR = useMemo(
    () => [
      { id: "stationId", label: "ID", alignRight: false, order: true },
      { id: "cluster", label: "Cluster", alignRight: false, order: true },
      {
        id: "componentType",
        label: t("Component"),
        alignRight: false,
        order: true,
      },
      { id: "type", label: t("Type of alarm"), alignRight: false, order: true },
      { id: "severity", label: t("Severity"), alignRight: false, order: true },
      {
        id: "creationDate",
        label: t("Date Validity"),
        alignRight: false,
        order: true,
      },
      { id: "isMuted", label: "", alignRight: false, order: true },
    ],
    [t]
  );

  const TABLE_HEAD = useMemo(
    () =>
      _.concat(
        { id: "info", label: "", alignRight: false, order: false },

        TABLE_HEAD_VISITOR
      ),
    [TABLE_HEAD_VISITOR]
  );

  const onRequestSort = useCallback(
    (event, property) => {
      const isAsc = order === "asc" ? "desc" : "asc";
      setOrder(isAsc);
      setOrderBy(property);
    },
    [order]
  );

  const handleFilterType = useCallback(
    (item) => {
      setCheckedType({ ...checkedType, [item]: !checkedType[item] });
      setPage(0);
    },
    [checkedType]
  );

  const handleSearchTable = useCallback(
    (e) => {
      const searchValue = e.target.value;
      setValueSearch(searchValue);

      const searchResult = values?.filter(
        (item) =>
          item.stationId?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.tag?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.alias?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.address?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.cluster?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.type?.toLowerCase().includes(searchValue.toLowerCase())
      );

      setCount(searchResult?.length);
      setDataFilter(searchResult);
    },
    // eslint-disable-next-line
    [values, search, zoneSelected]
  );

  const handleChangeZone = useCallback((item) => {
    setLoading(true);
    setZoneSelected(item);
    dispatch(saveCluster(item));
    setValues(null);
    setPage(0);
    // eslint-disable-next-line
  }, []);

  const onFailure = useCallback((error) => {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message
          ? error.response.data.message
          : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback((resp) => {
    setLoading(false);
    setIsFirstRefresh(true);
    dispatch(
      openSnackbar({
        open: true,
        message: resp.message,
        variant: "alert",
        alert: {
          color: resp.status,
        },
        close: false,
      })
    );
    setRefresh(true);
    // eslint-disable-next-line
  }, []);

  const onSuccessAlerts = useCallback((resp) => {
    setValues(resp?.alerts);
    setIsFirstRefresh(true);
    setIsFirstLoading(true);
    // eslint-disable-next-line
  }, []);

  const onError = useCallback(
    (error) => {
      setLoading(false);
      if (isFirstRefresh) {
        setLoading(false);
        if (error?.response?.status === 403) {
          onLogout(error);
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    []
  );

  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);

  const onClickMutate = useCallback(
    (alertId) => {
      setRefresh(false);
      setPage(0);
      Request.stations
        .setMuteAlert({ alert_id: alertId, token: token })
        .then((resp) => {
          onSuccess(resp);
        })
        .catch((error) => onError(error));
    },
    // eslint-disable-next-line
    [token, refresh]
  );

  const onPageChange = useCallback((event, newPage) => {
    setPage(newPage);
    // eslint-disable-next-line
  }, []);

  const onRowsPerPageChange = useCallback((event) => {
    setSlice(parseInt(event.target.value));
    setPage(0);
    // eslint-disable-next-line
  }, []);

  const onClickCheck = useCallback(
    (e) => {
      setLoading(true);
      setChecked({ ...checked, [e.target.name]: !checked[e.target.name] });
      setPage(0);
    },
    [checked]
  );

  const onClickStation = useCallback((item) => {
    dispatch(saveSearch(item));
    navigate("/dashboard/management/monitoring-points-list");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    //Ottengo dalla lista delle stazioni i cluster esistenti
    if (allStations && !_.isEmpty(allStations.stations)) {
      const clusters = allStations.stations.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.cluster === value.cluster)
      );
      const list = clusters.map((item) => {
        return item["cluster"];
      });

      setListClusters(list.sort());
    }
  }, [allStations, refresh]);

  useEffect(() => {
    const cluster =
      zoneSelected && !_.isEmpty(zoneSelected)
        ? `&cluster=${zoneSelected}`
        : "";
    Request.stations
      .getAlertsGeneric({
        cluster: cluster,
        token: token,
        muted: checked.mutati,
        inactive: checked.inattivi,
      })
      .then((resp) => {
        onSuccessAlerts(resp);
      })
      .catch((error) => onError(error));

    // eslint-disable-next-line
  }, [zoneSelected, token, checked, refresh, refresh_token]);

  useEffect(() => {
    setLoadingZone(true);
    setRefresh(false);
    Request.stations
      .allPoi({
        token: token,
      })
      .then((resp) => {
        setAllStations(resp);
        setLoadingZone(false);
        setIsFirstRefresh(true);
      })
      .catch((error) => onError(error));
    // eslint-disable-next-line
  }, [refresh, refresh_token, refresh]);

  useEffect(() => {
    if (values && allStations) {
      setLoading(true);

      if (!_.isEmpty(values)) {
        setCount(values.length);
      }

      let newValues = values;

      newValues?.map((item) => {
        item.cluster = _.find(allStations?.stations, function (o) {
          return o?.stationId === item?.stationId;
        })?.cluster;
        return newValues;
      });

      if (search) {
        setValueSearch(search);
        dispatch(saveSearch(null));
      } else {
        if (isFirstLoading) {
          setDataFilter(newValues);
          setIsFirstLoading(false);
        }
      }
      if (newValues === null || _.isEmpty(newValues)) {
        setWarning(true);
      }
      setValues(newValues);
      setLoading(false);
    }

    // eslint-disable-next-line
  }, [values, refresh, search, refresh_token, allStations, isFirstLoading]);

  useEffect(() => {
    setLoading(true);
    if (dataFilter) {
      setLoading(false);
      if (_.includes(Object.values(checkedType), true)) {
        const filterList = dataFilter?.filter(
          (item) => checkedType[item.componentType]
        );
        setDataFinal(filterList);
        setCount(filterList.length);
      } else {
        setDataFinal(dataFilter);
        setCount(dataFilter.length);
      }
    }
  }, [dataFilter, checkedType, refresh, search]);

  useEffect(() => {
    if (user && (user?.role === SUPERUSER || user?.role === OPERATOR)) {
      setIsVisitor(false);
    }
  }, [user]);

  useEffect(() => {
    if (valueSearch && (!isFirstLoading || !_.isEmpty(zoneSelected))) {
      handleSearchTable({ target: { value: valueSearch } });
    }
    // eslint-disable-next-line
  }, [valueSearch, isFirstLoading, zoneSelected, values]);

  const onRefresh = useCallback(() => {
    setRefresh(!refresh);
  }, [refresh]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ToolbarTableComponent
          listClusters={listClusters}
          handleChangeZone={handleChangeZone}
          loading={loadingZone}
          zoneSelected={zoneSelected}
          handleSearch={handleSearchTable}
          checked={checkedType}
          onClickFilter={handleFilterType}
          labelSearch={t("Search")}
          valueSearch={valueSearch}
          onRefresh={onRefresh}
        />
      </Grid>
      {!loadingZone && (
        <Grid item xs={12}>
          <MainCard title={t("Alarm list")} content={false}>
            <Grid item container xs={12} alignItems="center" display="flex">
              {warning ? (
                <Fragment>
                  <Grid item xs={12}>
                    <FormGroup
                      row
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: matchXS ? "start" : "end",
                        ml: matchXS && 1.5,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="inattivi"
                            checked={checked.inattivi}
                            onChange={onClickCheck}
                          />
                        }
                        label={t("Show inactive")}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="mutati"
                            checked={checked.mutati}
                            onChange={onClickCheck}
                          />
                        }
                        label={t("Show mutated")}
                      />
                    </FormGroup>
                  </Grid>

                  {loading ? (
                    <Grid item xs={12}>
                      <Loading />
                    </Grid>
                  ) : (
                    <Fragment>
                      <Grid item xs={12}>
                        <WarningListTable
                          header={
                            user?.role === SUPERUSER || user?.role === OPERATOR
                              ? TABLE_HEAD
                              : TABLE_HEAD_VISITOR
                          }
                          data={dataFinal}
                          page={page}
                          rowsPerPage={slice}
                          onClickMutate={onClickMutate}
                          onRequestSort={onRequestSort}
                          order={order}
                          orderBy={orderBy}
                          isVisitor={isVisitor}
                          onClickStation={onClickStation}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <ListPagination
                          rowsPerPageOptions={[10, 25, 50, 100, 250]}
                          component="div"
                          count={count}
                          rowsPerPage={slice}
                          page={page}
                          onPageChange={onPageChange}
                          onRowsPerPageChange={onRowsPerPageChange}
                        />
                      </Grid>
                    </Fragment>
                  )}
                </Fragment>
              ) : (
                <ErrorCardcomponent
                  sx={{ border: "none" }}
                  message={t("There is no warning")}
                />
              )}
            </Grid>
          </MainCard>
        </Grid>
      )}
    </Grid>
  );
};

export default WarningListContainer;
